module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/3d48b9570458ef3cf8cd66f3ae9d635e.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/epic.png
// module id = yzOm
// module chunks = 0